<template>
<div class="relative rectangle" :class="view_class_view.rectangle" v-if="showAd">
    <div :class="view_class_view.button_close" @click="closeAd">
        <img src="./assets/icon-x.svg" alt="icon-x" class="input-close">
    </div>
    <div :class="view_class_view.content" class="text-content">
        <slot name="content">
            <!-- Aquí va el contenido -->
        </slot>
    </div>
</div>
</template>
    
<script>
import {
    ref
} from "vue";

export default {
    name: "CarouselAds",
    props: {
        listImages: [],
        showNavigation: Boolean,
        showPagination: Boolean,
        loopVelocity: Number,
        loop: Boolean,
        view_class_view: {
            type: Object,
            default () {
                return {
                    rectangle: "",
                    button_close: "",
                    image: "",
                    content: ""
                }
            }
        },
    },

    setup() {
        const showAd = ref(true);

        function closeAd() {
            showAd.value = false;
        }

        return {
            showAd,
            closeAd
        };
    },
};
</script>
        
    
<style>
/* Rectangle */
.rectangle {
    box-sizing: border-box;

    position: absolute;
    padding-inline: 15px;
    padding-top: 11px;
    padding-bottom: 11px;

    background: #FFFFFF;
    border: 1px solid rgba(0, 0, 0, 0.1);
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.15);
    border-radius: 5px;
}

.input-close {
    position: absolute;
    right: -10px;
    top: -10px;
    cursor: pointer;
}

.text-content {
    font-family: sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    text-align: center;

    color: #2B231B;
}
</style>
